var map = {
	"./banner/sb00.png": "6575",
	"./banner/sb01.png": "5a3c",
	"./banner/sb02.png": "7fc7",
	"./banner/sb03.png": "e336",
	"./banner/sb04.png": "031d",
	"./banner/sb05.png": "c850",
	"./banner/sb06.png": "9cd5",
	"./banner/sb07.png": "f14d",
	"./banner/sb08.png": "592c",
	"./banner/sb09.png": "1852",
	"./banner/sb10.png": "fbd8",
	"./banner/sb11.png": "af42",
	"./banner/sb12.png": "c150",
	"./banner/sb13.png": "63ac",
	"./banner/sb14.png": "4efb",
	"./banner/sb15.png": "7c17",
	"./left.png": "34eb",
	"./logo.png": "9d64",
	"./next_button.png": "06c2",
	"./prev_button.png": "1d2c",
	"./right.png": "0f2a",
	"./star_off.png": "84ed",
	"./star_on.png": "a0a8",
	"./star_on_bak.png": "4d77",
	"./starbig_off.png": "8fc9",
	"./starbig_off_bak.png": "fcf7",
	"./starbig_on.png": "4167",
	"./timer.png": "7d74",
	"./timer_off.png": "0fde",
	"./timer_on.png": "4e8e",
	"./timerbig_off.png": "eb81",
	"./timerbig_off_bak.png": "750e",
	"./timerbig_on.png": "7a6c",
	"./top_logo.png": "342c",
	"./ucrmlogo.png": "eef8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";